import { VariantProps, cva } from 'class-variance-authority';

export const widgetStyles = cva('rounded-12', {
  variants: {
    variant: {
      elevated: 'bg-grayscale0 shadow-2',
    },
    padding: {
      normal: 'p-12',
      large: 'px-24 py-20',
    },
  },
  defaultVariants: {
    variant: 'elevated',
    padding: 'normal',
  },
});

export type WidgetStylesVariants = VariantProps<typeof widgetStyles>;
